<template>
    <v-autocomplete v-model="customView" :items="publishedCustomViews" item-value="id" item-text="linkTitle" :label="label|translate"
              :clearable="clearable">
    </v-autocomplete>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'CustomViewSelector',
    props: {
        value: String,
        label: {type: String, default: "Custom view"},
        clearable: {type: Boolean, default: true},
    },
    computed: {
        ...mapGetters([
            'publishedCustomViews'
        ]),
    },
    watch: {
        value() {
            if (this.customView !== this.value) {
                this.customView = this.value
            }
        },
        customView(newValue) {
            this.$emit('input', newValue)
        },
    },
    mounted() {
        if (this.value) {
            this.customView = this.value
        }
    },
    data() {
        return {
            customView: null,
        }
    },
}
</script>

<style scoped>

</style>
